import { render } from "./TeachingPlanTransferDialog.vue?vue&type=template&id=6689194f&scoped=true&ts=true"
import script from "./TeachingPlanTransferDialog.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanTransferDialog.vue?vue&type=script&lang=ts"

import "./TeachingPlanTransferDialog.vue?vue&type=style&index=0&id=6689194f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6689194f"]])

export default __exports__